import { ContactPageContent } from './shipsticks.page.content'

const content: ContactPageContent = {
  hero: {
    backgroundImage: '/images/shipskis/contact-us-hero.jpg',
    title: 'Contact Us',
    subtitle: "We're here to help - 7 days a week.",
    buttons: [],
  },
  mainContent: {
    title: 'Get in Touch with Us',
    description:
      "We don't do long hold times or confusing call trees. " +
      'Our dedicated support team is available 7 days a week ' +
      '(yes, even on weekends) to make sure you get the ' +
      'answers you need, when you need them.',
  },
  contactInfo: {
    address: '11400 N. Jog Road, Suite 300, Palm Beach Gardens, Florida 33418',
    textSupport: '(866) 761-7547',
    phoneNumber: '(866) 761-7547',
    officeHours: {
      weekdays: 'Mon - Fri\n8AM - 8PM EST',
      saturday: 'Sat\n8AM - 5PM EST',
      sunday: 'Sun\n9AM - 8PM EST',
    },
  },
  form: {
    title: "Let's chat.",
    subtitle: "We promise we'll get back to you within the next 24 hours",
    subjectOptions: [
      { value: 'need-quote', label: 'Need a quote' },
      { value: 'track-shipment', label: 'Track a shipment' },
      { value: 'how-it-works', label: 'How it works' },
      { value: 'becoming-partner', label: 'Becoming a partner' },
      { value: 'change-order', label: 'Make a change to my order' },
      { value: 'cancel-order', label: 'Cancel my order' },
      { value: 'unsubscribe', label: 'Remove/unsubscribe from email' },
      { value: 'other', label: 'Other' },
    ],
  },
  success: {
    title: 'Message Sent Successfully!',
    message: "Thank you for contacting us. We'll get back to you within 24 hours.",
    buttonText: 'Send Another Message',
  },
  socialMedia: [],
  googleMapsEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570.1234567890123!2d-80.' +
    '12345678901234!3d26.12345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2' +
    '!1s0x88d8d5c123456789%3A0x1234567890123456!2s11400%20N%20Jog%20Rd%2C%20Palm%20Beach%' +
    '20Gardens%2C%20FL%2033418!5e0!3m2!1sen!2sus!4v1234567890123',
}

export default content
